 import { readable,derived ,writable} from 'svelte/store'
import { urlServeur } from '../components/conf.js'


/**
 * Créer un magasin avec toutes les dépenses
 */
 const depenses = readable(null,  function start(set) {
    fetch(urlServeur + "/api/immeubles/opedepenses/")
        .then(function (response) {
            if (!response.ok) {
                throw new Error('unable to load recettes on recettesstore init');
            }
            return response.json();
        })
        .then(function (data) {
            const liste = data.payload;
            //console.log(liste)
            set(liste);
        });

    return function stop() {
        console.log('DépensesStore Stopped');
    };
});


/**
 * Store pour le popup utilisé pour la rechercher
 */
export const anneePopUp = writable(0);

/**
 *  Magasin dérivé des dépenses et du tableau Années
 */
export const filtered = derived([depenses, anneePopUp], ([$depenses, $anneePopUp]) => {
   // console.log($anneePopUp)
    if ($anneePopUp == 0) {
        return $depenses
    } else {
        return $depenses.filter((item) => parseInt(item.year) === $anneePopUp);
    }

})
